import script from "./MobActionsLegendary.vue?vue&type=script&setup=true&lang=js"
export * from "./MobActionsLegendary.vue?vue&type=script&setup=true&lang=js"

import "./MobActionsLegendary.vue?vue&type=style&index=0&id=2c9589f0&lang=css"

const __exports__ = script;

export default __exports__